import { render, staticRenderFns } from "./AdminUserCreateView.vue?vue&type=template&id=135b8245&"
import script from "./AdminUserCreateView.vue?vue&type=script&lang=js&"
export * from "./AdminUserCreateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports